import { render, staticRenderFns } from "./SYthreeTerminal.vue?vue&type=template&id=1eaab48f&scoped=true&"
import script from "./SYthreeTerminal.vue?vue&type=script&lang=js&"
export * from "./SYthreeTerminal.vue?vue&type=script&lang=js&"
import style0 from "./SYthreeTerminal.vue?vue&type=style&index=0&id=1eaab48f&prod&lang=less&"
import style1 from "./SYthreeTerminal.vue?vue&type=style&index=1&id=1eaab48f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaab48f",
  null
  
)

export default component.exports